import axios from "axios";

import rootURL from "utils/RootURL";
import { formatHeaders } from "utils/Api";

export const getCustomJSON = (token, projectSlug, callback) => {
  axios({
    url: rootURL(
      `/api/project/v3/admin/storefront_projects/user_custom_values`,
    ),
    method: "GET",
    headers: {
      ...formatHeaders(token, [
        {
          key: "xx-ok-project",
          value: projectSlug,
        },
      ]),
    },
  }).then((json) => {
    callback(json);
  });
};

export const checkCustomJSON = (
  file,
  token,
  projectSlug,
  onUploadProgress,
  callback,
  callbackError,
) => {
  axios({
    url: rootURL(
      `/api/project/v3/admin/storefront_projects/user_custom_values`,
    ),
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      ...formatHeaders(token, [
        {
          key: "xx-ok-project",
          value: projectSlug,
        },
      ]),
    },
    data: { file: file.base64, filename: file.name },
    onUploadProgress,
  })
    .then((json) => {
      callback(json);
    })
    .catch(({ response }) => {
      callbackError({ response });
    });
};
